export default __webpack_public_path__ + "static/media/italian-army.64083045.jpg";